// import hooks
import { useQuery, UseQueryOptions } from 'react-query';

// import queries & mutations
import {
  EmployeeNotesResponse,
  getEmployeeNotes
} from 'RestAPIs/employees/notes';

// import types
import { UseGetEmployeeNotesProps } from './useGetEmployeeNotes.types';

const useGetEmployeeNotes = (
  { employeeId }: UseGetEmployeeNotesProps,
  options: UseQueryOptions<EmployeeNotesResponse[]> = {}
) => {
  const {
    data = [],
    isFetching,
    isError,
    refetch
  } = useQuery<EmployeeNotesResponse[]>(
    ['employeeNotes', 'list', employeeId],
    () => getEmployeeNotes({ employeeId }).then((response) => response.data),
    {
      ...options
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeNotes;
